// inline CSS custom-property overrides; bind on the element that carries the design class
export function tokenOverrides(prefix, vars) {
    const style = {}
    for (const [k, v] of Object.entries(vars || {})) {
        style[`--${prefix}-${k}`] = v
    }
    return style
}
